import React from 'react';
import { useSelector } from 'react-redux';
import {
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Grid,
  Checkbox,
  Stack
} from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';

const ParticipantDataForm = ({ formik }) => {
  const { order } = useSelector(state => state.orderData);

  return (
    <Card>
      <CardHeader title="Dane uczestnika" sx={{ mt: -1, mb: -2 }} />
      <CardContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="subtitle2">Dieta</Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                select
                name="diet"
                placeholder="dieta"
                label={formik.values.diet === '' ? 'brak wybranej diety' : null}
                value={formik.values.diet}
                onChange={formik.handleChange}
                options={[
                  { value: '', label: 'Brak wybranej diety' },
                  ...order.diets
                ]}
                error={formik.touched.diet && Boolean(formik.errors.diet)}
                helperText={formik.touched.diet && formik.errors.diet}
                multiline
                rows={6}
              />
              <Box height={10}/>
              <Typography variant="subtitle2">
                Dieta uczestnika dodatkowe informacje
              </Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="participant_diet"
                type="text"
                placeholder="Dieta uczestnika dodatkowe informacje"
                multiline
                rows={6}
                value={formik.values.participant_diet}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle2">
                Inne uwagi dotyczące uczestnika
              </Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="participant_other_comments"
                type="text"
                placeholder="inne uwagi dotyczące uczestnika"
                multiline
                rows={9}
                value={formik.values.participant_other_comments}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle2">Stałe leki uczestnika</Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="participant_regular_medication"
                type="text"
                placeholder="stałe leki uczestnika"
                multiline
                rows={6}
                value={formik.values.participant_regular_medication}
                onChange={formik.handleChange}
              />
            </Grid>

            <Grid item xs={6}>
              <Typography variant="subtitle2">Choroby i uczulenia</Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="participant_diseases_and_allergies"
                type="text"
                placeholder="choroby i alergie"
                multiline
                rows={6}
                value={formik.values.participant_diseases_and_allergies}
                onChange={formik.handleChange}
              />
            </Grid>

            <Grid item xs={6}>
              <Typography variant="subtitle2">Zachowanie uczestnika</Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="participant_behavior"
                type="text"
                placeholder="zachowanie uczestnika"
                multiline
                rows={6}
                value={formik.values.participant_behavior}
                onChange={formik.handleChange}
              />
            </Grid>


            <Grid item xs={6}>
              <Typography variant="subtitle2">
                Rodzeństwo/Przyjaciele
              </Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="participant_siblings_and_friends"
                type="text"
                placeholder="rodzeństwo/przyjaciele"
                multiline
                rows={6}
                value={formik.values.participant_siblings_and_friends}
                onChange={formik.handleChange}
              />
            </Grid>

            <Grid item xs={6}>
              <Typography variant="subtitle2">
                Uwagi dotyczące zakwaterowania
              </Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="shared_accommodation_info"
                type="text"
                placeholder="uwagi dotyczące zakwaterowania"
                multiline
                rows={6}
                value={formik.values.shared_accommodation_info}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle2">
                Inne dzieci
              </Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="other_kids"
                type="text"
                placeholder=""
                disabled
                multiline
                rows={3}
                value={order.other_kids_display}
              />
            </Grid>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center">
                <Checkbox
                  id="child_english_communicative"
                  name="child_english_communicative"
                  checked={formik.values.child_english_communicative}
                  onChange={formik.handleChange}
                />
                <Typography variant="subtitle2">Znajomość języka angielskiego</Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle2">
                Wiadomość od biura
              </Typography>
              <SmallFormTextField
                sx={{ width: '100%' }}
                name="message_from_office"
                type="text"
                placeholder="wiadomość od biura"
                multiline
                rows={6}
                value={formik.values.message_from_office}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default ParticipantDataForm;
